import React from "react";
import { useHistory } from "react-router-dom";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
class SolicitudAL extends React.Component {
  constructor(props) {
    super(props);

    /* Establecimientos */
    this.handleEstablecimientoDocumentoStatus =
      this.handleEstablecimientoDocumentoStatus.bind(this);
    this.handleDownloadZipEstablecimientos =
      this.handleDownloadZipEstablecimientos.bind(this);
    this.allDocsEst = this.allDocsEst.bind(this);
    this.handleEstablecimientoStatus =
      this.handleEstablecimientoStatus.bind(this); //SINAIP 1 SI APRUEBA
    this.handleSearch = this.handleSearch.bind(this);
    this.handleEstablecimientoPage = this.handleEstablecimientoPage.bind(this);
    this.handleOpenEstablecimiento = this.handleOpenEstablecimiento.bind(this);
    this.handleEstChecks = this.handleEstChecks.bind(this);
    this.handleEstBtn = this.handleEstBtn.bind(this);
    /* Termina establecimientos */
    /* Productos **/
    this.handleProductoStatus = this.handleProductoStatus.bind(this); //SINAIP 1 SI APRUEBA
    this.handleDownloadZipProductos =
      this.handleDownloadZipProductos.bind(this);
    this.allDocsPro = this.allDocsPro.bind(this);
    this.handleProductoPage = this.handleProductoPage.bind(this);
    this.handleOpenProductos = this.handleOpenProductos.bind(this);
    this.handleProductosDocumentoStatus =
      this.handleProductosDocumentoStatus.bind(this);
    this.handleChangeStatusProducto =
      this.handleChangeStatusProducto.bind(this);
    this.handleClasificacionProd = this.handleClasificacionProd.bind(this);
    this.handleProChecks = this.handleProChecks.bind(this);
    /* Termina productos */

    this.handlePrevia = this.handlePrevia.bind(this);
    this.handleCreateLicense = this.handleCreateLicense.bind(this);

    this.state = {
      previa: false,
      previa_url: "",
      working: true,
      modalRegente: false,
      modalEstablecimiento: false,
      modalPago: false,
      toggle: false,
      paginaActual: 0,
      paginaActual_e: 0,
      paginas: 0,
      nivelUsuario: localStorage.nivel_actual,
      paginas_e: 0,
      registros: 0,
      registros_e: 0,
      regentes: [],
      regenteDocsCheck: [],
      establecimientoDocsCheck: [],
      allRc: false,
      allEst: false,
      accionCombo: Api.loadCatalogue("cat_accion"),
      tipoRegenteCombo: Api.loadCatalogue("cat_tipo_regente"),
      estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
      tipo_establecimiento: Api.loadCatalogue("cat_tipo_establecimiento"),
      actividad_establecimiento: Api.loadCatalogue("cat_actividad"),
      cat_tipo_producto: Api.loadCatalogue("cat_tipo_producto"),
      am: "", //es nota marginal
      nota_marginal: {},
      regente: {
        name: "",
        apellido_paterno: "",
        apellido_materno: "",
        folio_solicitud: "",
        sexo: "",
        departamento: "",
        municipio: "",
        email: "",
        telefono: "",
        celular: "",
        fecha_solicitud: "",
        documentos: [],
      },
      activeTab: "1",
      buscar: {},
      buscarEstablecimientos: {},
      buscarProductos: {},
      collapse: [
        { id: 1, collapse: true },
        { id: 2, collapse: false },
        //{ id: 3, collapse: false },
      ],
      establecimientos: [],
      id_establecimiento: "",
      solicitud_est: {
        id: "",
        folio_solicitud: "",
        fecha_solicitud: "",
        accion: "",
        actividad: "",
        tipo: "",
        estatus: "",
        //documentos:[],
      },
      establecimiento: {
        caracteristicas: [],
        documentos: [],
        establecimiento: {},
        regentes: [],
        representante_legal: [],
        solicitud: {},
      },
      id_producto: "",
      solicitud_prod: {
        id: "",
        folio_solicitud: "",
        fecha_solicitud: "",
        accion: "",
        actividad: "",
        tipo: "",
        estatus: "",
      },
      producto: {
        id: "",
        forma_farmaceutica: "",
        forma_farmaceutica_id: "",
        folio: "",
        medida_tiempo: "",
        medida_tiepo_id: "",
        nombre_comercial: "",
        pais: "",
        pais_id: "",
        precauciones_generales: "",
        uso: "",
      },
      productos: [],
      solicitud_pro: {},
      productoDocsCheck: [],
      paginaActual_p: 0,
      paginas_p: 0,
      registros_p: 0,
      docProductos: [],
    };

    this.toggleCollapse = this.toggleCollapse.bind(this);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleCollapse(index) {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({
      collapse: newArray,
    });
  }

  detalleEstablecimientoAS = "";
  detalleRepresentante = "";
  detalleRegente = "";
  detalleCaracteristicas = "";
  detalleCondiciones = "";
  regente = {};
  representante_legal = {};
  condiciones = {};
  principioActivo = {};
  excipiente = {};
  tabla_dosis = {};
  tabla_envase = {};
  tabla_periodo = {};
  tabla_com_biologica = {};
  tabla_com_quimica = {};
  detalleProducto = "";
  AnotacionProducto = "";
  representante_legal_pro = {};
  regente_pro = {};
  tabla_biologico = {};
  tabla_quimica = {};
  tabla_modo_empleo = {};
  tabla_componentes = {};
  tabla_especies = {};
  tabla_presentacion = {};
  tabla_analisis = {};
  tabla_ingredientes = {};
  clasificacion = "";

  setProductosPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscarProductos;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch(
      "app/getSolicitudesProductos?asesoria=1&estatus=10&page=" + page + src
    ).then((p) => {
      this.setState({
        productos: p.data,
        paginas_p: p.last_page,
        registros_p: p.total,
        paginaActual_p: p.current_page,
        workingGrid: false,
      });
    });
  }

  //Funcion auxiliar para cambiar de pagina en el grid de productos
  handleProductoPage(e) {
    this.setProductosPage(e.target.value);
  }

  handleOpenProductos(e) {
    let tituloModal = e.target.dataset.folio;

    let solid = e.target.getAttribute("data-solicitud-id");
    let detalle = document.querySelector("#detalleProducto2");

    Api.loading(true);

    Api.fetch("app/getSolicitudProducto?id=" + solid).then((e) => {
      this.setState({
        producto: e.producto,
        solicitud_prod: e.solicitud,
        allPro: false,
        //dsp:e.dsp,
        working: false,
      });

      if (parseInt(e.producto.tipo_producto_veterinario_id)) {
        this.detalleProducto.querySelector(
          ".forma_farmaceutica label"
        ).innerText = "Forma farmacéutica";
      } else {
        this.detalleProducto.querySelector(
          ".forma_farmaceutica label"
        ).innerText = "Forma de comercialización";
      }

      //this.handleProBtn();

      this.detalleProducto.merge(e.producto);

      if (e.producto.tipo_producto_veterinario_id === "1") {
        // MEDICAMENTO VETERINARIO
        this.detalleProducto.querySelector(".precauciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(
          ".precauciones_almacenamiento"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".propiedades_inmunologicas"
        ).style.display = "none";
        this.detalleProducto.querySelector(".instrucciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(".clasificacion").style.display =
          "none";

        this.detalleProducto.querySelector(
          ".precauciones_generales"
        ).style.display = "";
        this.detalleProducto.querySelector(
          ".validez_preparacion"
        ).style.display = "";
        this.detalleProducto.querySelector(".uso").style.display = "";
        this.detalleProducto.querySelector(
          ".forma_farmaceutica"
        ).style.display = "";
      } else if (e.producto.tipo_producto_veterinario_id === "2") {
        // BIOLOGICO
        this.detalleProducto.querySelector(
          ".precauciones_generales"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".validez_preparacion"
        ).style.display = "none";
        this.detalleProducto.querySelector(".uso").style.display = "none";
        this.detalleProducto.querySelector(".instrucciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(".clasificacion").style.display =
          "none";

        this.detalleProducto.querySelector(".precauciones_uso").style.display =
          "";
        this.detalleProducto.querySelector(
          ".precauciones_almacenamiento"
        ).style.display = "";
        this.detalleProducto.querySelector(
          ".propiedades_inmunologicas"
        ).style.display = "";
        this.detalleProducto.querySelector(
          ".forma_farmaceutica"
        ).style.display = "";
      } else if (e.producto.tipo_producto_veterinario_id === "3") {
        // PRODUCTO AFIN
        this.detalleProducto.querySelector(".precauciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(
          ".precauciones_almacenamiento"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".propiedades_inmunologicas"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".validez_preparacion"
        ).style.display = "none";
        this.detalleProducto.querySelector(".instrucciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(".clasificacion").style.display =
          "none";

        this.detalleProducto.querySelector(
          ".forma_farmaceutica"
        ).style.display = "";
        this.detalleProducto.querySelector(
          ".precauciones_generales"
        ).style.display = "";
        this.detalleProducto.querySelector(".uso").style.display = "";
      } else if (e.producto.tipo_producto_veterinario_id === "4") {
        // REACTIVO DIAGNOSTICO
        this.detalleProducto.querySelector(".precauciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(
          ".precauciones_almacenamiento"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".propiedades_inmunologicas"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".validez_preparacion"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".forma_farmaceutica"
        ).style.display = "none";
        this.detalleProducto.querySelector(".clasificacion").style.display =
          "none";

        this.detalleProducto.querySelector(
          ".precauciones_generales"
        ).style.display = "";
        this.detalleProducto.querySelector(".uso").style.display = "";
        this.detalleProducto.querySelector(".instrucciones_uso").style.display =
          "";
      } else if (e.producto.tipo_producto_veterinario_id === "5") {
        // ALIMENTACION
        this.detalleProducto.querySelector(
          ".precauciones_generales"
        ).style.display = "none";
        this.detalleProducto.querySelector(
          ".validez_preparacion"
        ).style.display = "none";
        this.detalleProducto.querySelector(".instrucciones_uso").style.display =
          "none";
        this.detalleProducto.querySelector(
          ".propiedades_inmunologicas"
        ).style.display = "none";

        this.detalleProducto.querySelector(".clasificacion").style.display = "";
        this.detalleProducto.querySelector(".precauciones_uso").style.display =
          "";
        this.detalleProducto.querySelector(
          ".precauciones_almacenamiento"
        ).style.display = "";
        this.detalleProducto.querySelector(
          ".forma_farmaceutica"
        ).style.display = "";
      }

      if (
        e.solicitud.tipo_producto_veterinario_id === "1" ||
        e.solicitud.tipo_producto_veterinario_id === "3"
      ) {
        //PRINCIPIO ACTIVO
        this.principioActivo.source =
          "app/getActivoProducto?id=" + e.producto.id + "&";
        Api.grid(this.principioActivo);
        //EXCIPIENTE
        this.excipiente.source =
          "app/getExcipienteProducto?id=" + e.producto.id + "&";
        Api.grid(this.excipiente);
      }

      if (e.solicitud.tipo_producto_veterinario_id === "2") {
        //PRINCIPIO ACTIVO
        this.tabla_biologica.source =
          "app/getComposicionBiologica?id=" + e.producto.id + "&";
        Api.grid(this.tabla_biologica);
        //EXCIPIENTE
        this.tabla_quimica.source =
          "app/getComposicionQuimica?id=" + e.producto.id + "&";
        Api.grid(this.tabla_quimica);
      }

      if (
        e.solicitud.tipo_producto_veterinario_id === "1" ||
        e.solicitud.tipo_producto_veterinario_id === "2" ||
        e.solicitud.tipo_producto_veterinario_id === "5"
      ) {
        //DOSIS
        this.tabla_dosis.source =
          "app/getDosisProducto?id=" + e.producto.id + "&";
        Api.grid(this.tabla_dosis);
        //ENVASE
        this.tabla_envase.source =
          "app/getEnvaseProducto?id=" + e.producto.id + "&";
        Api.grid(this.tabla_envase);
        //PERIODO DESCARTE
        this.tabla_periodo.source =
          "app/getDescarteProducto?id=" + e.producto.id + "&";
        Api.grid(this.tabla_periodo);
      }

      if (e.solicitud.tipo_producto_veterinario_id === "3") {
        //MODO EMPLEO - falta
        this.tabla_modo_empleo.source =
          "app/getDosisProducto?id=" + e.producto.id + "&";
        Api.grid(this.tabla_modo_empleo);
        //ENVASE
        this.tabla_envase.source =
          "app/getEnvaseProducto?id=" + e.producto.id + "&";
        Api.grid(this.tabla_envase);
      }

      if (e.solicitud.tipo_producto_veterinario_id === "4") {
        //COMPONENTES
        this.tabla_componentes.source =
          "app/getComponente?id=" + e.producto.id + "&";
        Api.grid(this.tabla_componentes);
        //ESPECIE INTERES
        this.tabla_especies.source =
          "app/getEspecieInteres?id=" + e.producto.id + "&";
        Api.grid(this.tabla_especies);
        //PRESENTACIONES
        this.tabla_presentacion.source =
          "app/getPresentacion?id=" + e.producto.id + "&";
        Api.grid(this.tabla_presentacion);
      }

      if (e.solicitud.tipo_producto_veterinario_id === "5") {
        //ANALISIS GARANTIZADO
        this.tabla_analisis.source =
          "app/getAnalisisAlimento?id=" + e.producto.id + "&";
        Api.grid(this.tabla_analisis);
        //INGREDIENTE
        this.tabla_ingredientes.source =
          "app/getIngredienteAnimal?id=" + e.producto.id + "&";
        Api.grid(this.tabla_ingredientes);
      }

      //REPRESENTANTES
      /*           this.representante_legal_pro.source= 'app/getRepresentanteProducto?id='+e.producto.id+'&';
          Api.grid(this.representante_legal_pro); */
      //REGENTES
      this.regente_pro.source =
        "app/getRegenteProducto?id=" + e.producto.id + "&";
      Api.grid(this.regente_pro);

      if (e.solicitud.anotacion_marginal) {
        //this.AnotacionProducto.querySelector(".precauciones_generales").style.display = "none";

        this.AnotacionProducto.querySelector(
          ".anotacion_marginal_peticion label"
        ).innerHTML = e.solicitud.anotacion_marginal_name;
        this.AnotacionProducto.merge(e.solicitud);
      }

      Api.fetch("app/getProductDocsDetails?solicitud_id=" + solid).then(
        (files) => {
          Api.loading(0);
          this.setState({
            docProductos: files,
            working: false,
            solicitud_pro: { id: solid },
          });

          let docAcepta = detalle.querySelectorAll(".documento-pro-rechazar");

          docAcepta.forEach((doc) => {
            doc.addEventListener("click", this.handleProductosDocumentoStatus);
          });

          let docRechaza = detalle.querySelectorAll(".documento-pro-aceptar");

          docRechaza.forEach((doc) => {
            doc.addEventListener("click", this.handleProductosDocumentoStatus);
          });

          let docVistaPrevia = detalle.querySelectorAll(".vista-previa");
          docVistaPrevia.forEach((doc) => {
            doc.addEventListener("click", this.handlePrevia);
          });

          let checkboxs = detalle.querySelectorAll(".checkbox_pro_a");
          checkboxs.forEach((doc) => {
            doc.addEventListener("onchange", this.handleProChecks);
          });
          detalle
            .querySelector("#regresar_pro_a")
            .addEventListener("click", () => {
              this.modalProAS.close();
            });

          detalle
            .querySelector("#rechazar_pro_a")
            .addEventListener("click", this.handleProductoStatus);
          detalle
            .querySelector("#aprobar_pro_a")
            .addEventListener("click", this.handleProductoStatus);
          detalle
            .querySelector("#allc_p_a")
            .addEventListener("change", this.allDocsPro);
          detalle
            .querySelector("#descarga_docs_pro_a")
            .addEventListener("click", this.handleDownloadZipProductos);
          this.handleProBtn();
          Api.loading(false);

          /*Abrimos el modal */
          this.modalProAS = Api.modal({
            title: "Folio solicitud: " + tituloModal,
            html: detalle,
          });
        }
      );

      //Api.loading(false);
    });
  }

  componentDidMount() {
    // si el usuario no es nivel asesoría legal redireccionamos a home
    if (this.state.nivelUsuario !== "4") {
      window.location.href = "/";
    }

    this.setState({
      buscar: this.search,
    });

    this.setProductosPage(1);
    this.setEstablecimientosPage(1);

    /*Buscador establecimiento */
    let bestablecimiento = {
      target: "#busquedaEstablecimiento",
      nombre: "busquedaEstablecimiento",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 2,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          select: {
            cols: 2,
            name: "solicitud",
            type: "text",
            label: "Trámite",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 4,
            name: "razon_social",
            type: "text",
            label: "Razón social",
          },
        },
        {
          select: {
            cols: 4,
            name: "tipo",
            label: "Tipo establecimiento",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.tipo_establecimiento.forEach((s) => {
                me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 2,
            name: "actividad",
            label: "Actividad",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.actividad_establecimiento.forEach((s) => {
                me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 2,
            name: "ffecha",
            label: "Rango fecha",
            render: (me) => {
              me.innerHTML = `
                              <option value="">Seleccione</option>
                              <option value="fecha_solicitud">Solicitud</option>
                              <option value="fecha_aprueba_sinaip">Aprueba SINAIP</option>
                        `;
            },
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        /* { //siempre van a aprecer en espera de acesoria legal
          select: {
            cols: 2,
            name: "estatus",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        }, */
        {
          button: {
            cols: 2,
            name: "buscaest",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning",
            icon: "fas fa-search",
            click: () => {
              this.setState({
                buscarEstablecimientos: bestablecimiento.data(),
              });
              this.setEstablecimientosPage(1);
            },
          },
        },
      ],
    };

    bestablecimiento = Api.form(bestablecimiento);
    /* FIN DEL BUSCADOR DE ESTABLECIMIENTO */

    /*Buscador productos */
    let bproducto = {
      target: "#busquedaProducto",
      nombre: "busquedaProducto",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 2,
            name: "folio",
            type: "text",
            label: "Folio",
          },
        },
        {
          select: {
            cols: 2,
            name: "solicitud",
            type: "text",
            label: "Trámite",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            cols: 4,
            name: "nombre_comercial",
            type: "text",
            label: "Nombre comercial",
          },
        },
        {
          select: {
            cols: 4,
            name: "tipo",
            label: "Tipo producto",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_tipo_producto.forEach((s) => {
                me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 3,
            name: "ffecha",
            label: "Rango fecha",
            render: (me) => {
              me.innerHTML = `
                            <option value="">Seleccione</option>
                            <option value="fecha_solicitud">Solicitud</option>
                            <option value="fecha_aprueba_sinaip">Aprueba SINAIP</option>
                      `;
            },
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        {
          button: {
            cols: 3,
            name: "buscaest",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning",
            icon: "fas fa-search",
            click: () => {
              this.setState({ buscarProductos: bproducto.data() });
              this.setProductosPage(1);
            },
          },
        },
      ],
    };

    bproducto = Api.form(bproducto);
    /* Termina buscador productos */

    /**DEFINO MI FORMA para detalles de establecimiento */
    let forma = {
      target: "#establecimiento",
      //disabled:true,
      nombre: "formatica",
      onchange: () => {},
      render: () => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 6,
            name: "razon_social",
            type: "text",
            label: "Razón social",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "telefono",
            type: "text",
            label: "Teléfono activo",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "correo_electronico",
            type: "text",
            label: "Correo electrónico activo",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "numero_de_identificacion",
            type: "text",
            label: "Cédula RUC",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "direccion",
            type: "text",
            label: "Dirección",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "municipio",
            type: "text",
            label: "Municipio",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "departamento",
            type: "text",
            label: "Departamento",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "latitud",
            type: "text",
            label: "Latitud",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "longitud",
            type: "text",
            label: "Longitud",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "pais_texto",
            type: "text",
            label: "País",
            disabled: true,
          },
        },
      ],
    };
    this.detalleEstablecimientoAS = Api.form(forma);

    /**DEFINO MI FORMA para detalles de representante TABLA*/
    this.representante_legal = {
      //source: "app/getRepresentanteEstablecimiento?id=5&",
      target: "#representanteLegal",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando representantes legales", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido Materno",
        },
        correo_electronico: {
          label: "Correo electrónico",
        },
      },
    };

    /**DEFINO MI FORMA para detalles de regente TABLA*/
    this.regente = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#regente",
      tableClass: "table table-striped m-b-0 table-hover ", //blockea las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando regentes", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido materno",
        },
        guid: {
          label: "GUID",
        },
      },
    };

    /**DEFINO MI FORMA para detalles de características TABLA*/
    this.condiciones = {
      //source:'app/getCondicionesEstablecimiento?id=26&',
      target: "#condiciones",
      tableClass: "table table-striped m-b-0 table-hover ", //blockea las clases de estilo de la tabla
      progressText: "Cargando condiciones", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rowsPerPage: [5, 10, 25, 50, 100],
      rows: {
        condiciones: {
          label: "Condiciones",
        },
      },
    };

    let caracteristicas = {
      target: "#caracteristicas",
      disabled: false,
      nombre: "formatica",
      render: () => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 12,
            name: "area",
            type: "text",
            label: "Área total(m²)",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "direccion_bodegas",
            type: "text",
            label: "Dirección de bodegas y almacenamiento",
            disabled: true,
          },
        },
      ],
    };
    this.detalleCaracteristicas = Api.form(caracteristicas);

    /**********DEFINO MI FORMA para detalles del tipo de producto TABLA*/

    /*   this.principioActivo = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#producto_activo",
      tableClass: "table table-striped m-b-0 table-hover", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando principio_activo", //El mensaje de carga
      hidePager: true, //Oculta el paginador
   
      rows: {
        ingrediente: {
          label: "Principio activo",
        },
        concentracion: {
          label: "Concentración",
        },
        unidad_medida: {
          label: "Unidad de medida pa",
        },
      },
    };

    this.excipiente = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#excipiente",
      tableClass: "table table-striped m-b-0 table-hover", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando excipiente", //El mensaje de carga

      hidePager: true, //Oculta el paginador
      rows: {
        excipiente: {
          label: "excipiente",
        },
        concentracion: {
          label: "Concentración",
        },
        unidad_medida: {
          label: "Unidad de medida pa",
        },
      },
    };
      
    this.tabla_dosis = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#dosis",
      tableClass: "table table-striped m-b-0 table-hover", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando dosis", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        dosis: {
          label: "Dosis por especie y vía de administracion",
        },
        especie: {
          label: "Especie de destino",
        },
        categoria: {
          label: "Categoría",
        },
      },
    };

    this.tabla_envase = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#envase",
      tableClass: "table table-striped m-b-0 table-hover", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando envase", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        envase: {
          label: "Tipo envase/empaque",
        },
        presentacion: {
          label: "Presentaciones",
        },
        cantidad: {
          label: "Cantidad",
        },
        unidad_medida: {
          label: "Unidad de medida",
        },
      },
    };
    
    this.tabla_periodo = {
      //source:'app/getCondicionesEstablecimiento?id=26&',
      target: "#periodo",
      tableClass: "table table-striped m-b-0 table-hover", //las clases de estilo de la tabla
      progressText: "Cargando periodo", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rowsPerPage: [5, 10, 25, 50, 100],
      rows: {
        periodo: {
          label: "Periodo de retiro/descarte (días)",
        },
        especie: {
          label: "Especie",
        },
      },
    };

    this.tabla_com_biologica = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#tabla_com_biologica",
      tableClass: "table table-striped m-b-0 table-hover", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando principio_activo", //El mensaje de carga
      hidePager: true, //Oculta el paginador
   
      rows: {
        composicion: {
          label: "Composición biológica",
        },
        titulo: {
          label: "Título",
        },
      },
    };

    this.tabla_com_quimica = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#tabla_com_quimica",
      tableClass: "table table-striped m-b-0 table-hover", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando principio_activo", //El mensaje de carga
      hidePager: true, //Oculta el paginador
   
      rows: {
        composicion: {
          label: "Composición química",
        },
        concentracion: {
          label: "Concentración",
        },
        unidad_medida: {
          label: "Unidad de medida",
        },
      },
    }; */

    let detalle_producto = {
      target: "#d_producto",
      disabled: false,
      nombre: "producto",
      render: () => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 12,
            name: "nombre_comercial",
            type: "text",
            label: "Nombre comercial",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "clasificacion",
            type: "text",
            label: "Clasificación",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "precauciones_generales",
            type: "textarea",
            label: "Precauciones generales",
            disabled: true,
          },
        },

        {
          input: {
            cols: 6,
            name: "precauciones_uso",
            type: "textarea",
            label: "Precauciones de uso",
            disabled: true,
          },
        },

        {
          input: {
            cols: 6,
            name: "precauciones_almacenamiento",
            type: "textarea",
            label: "Precauciones almacenamiento",
            disabled: true,
          },
        },

        {
          input: {
            cols: 8,
            name: "caducidad",
            type: "text",
            label: "Caducidad del producto",
            disabled: true,
          },
        },
        {
          input: {
            cols: 4,
            name: "medida_tiempo",
            type: "text",
            label: "Tiempo",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "forma_farmaceutica",
            type: "text",
            label: "Forma farmaceutica",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "pais",
            type: "text",
            label: "País de origen",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "uso",
            type: "textarea",
            label: "Indicaciones de uso",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "instrucciones_uso",
            type: "textarea",
            label: "Instrucciones de uso",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "validez_preparacion",
            type: "text",
            label: "Validez para preparación extemporánea",
            disabled: true,
          },
        },
        {
          input: {
            cols: 12,
            name: "propiedades_inmunologicas",
            type: "text",
            label: "Propiedades inmunológicas",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "fabricante",
            type: "text",
            label: "Fabricante",
            disabled: true,
          },
        },
        {
          input: {
            cols: 6,
            name: "titular",
            type: "text",
            label: "Titular",
            disabled: true,
          },
        },
      ],
    };
    this.detalleProducto = Api.form(detalle_producto);

    /**DEFINO MI FORMA para detalles de representante para producto TABLA*/
    this.representante_legal_pro = {
      //source: "app/getRepresentanteProducto?id=5&",
      target: "#representanteLegal_pro",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando representantes legales", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido Materno",
        },
        correo_electronico: {
          label: "Correo electrónico",
        },
      },
    };

    /**DEFINO MI FORMA para detalles de regente para producto TABLA*/
    this.regente_pro = {
      //source:'app/getRegenteProducto?id=1&',
      target: "#regente_pro",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando regentes", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido materno",
        },
        guid: {
          label: "GUID",
        },
      },
    };

    ///////////////
    this.principioActivo = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#producto_activo",
      tableClass: "table table-striped m-b-0 table-hover blockea", // blockea las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando principio_activo", //El mensaje de carga
      hidePager: true, //Oculta el paginador

      rows: {
        ingrediente: {
          label: "Principio activo",
        },
        concentracion: {
          label: "Concentración",
        },
        unidad_medida: {
          label: "Unidad de medida pa",
        },
      },
    };

    this.excipiente = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#excipiente",
      tableClass: "table table-striped m-b-0 table-hover blockea", //blockea las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando excipiente", //El mensaje de carga

      hidePager: true, //Oculta el paginador
      rows: {
        excipiente: {
          label: "excipiente",
        },
        concentracion: {
          label: "Concentración",
        },
        unidad_medida: {
          label: "Unidad de medida pa",
        },
      },
    };

    this.tabla_dosis = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#dosis",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando dosis", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        dosis: {
          label: "Dosis por especie y vía de administracion",
        },
        especie: {
          label: "Especie de destino",
        },
        categoria: {
          label: "Categoría",
        },
      },
    };

    this.tabla_envase = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#envase",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando envase", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        envase: {
          label: "Tipo envase/empaque",
        },
        /*  presentacion: {
      label: "Presentaciones",
    }, */
        cantidad: {
          label: "Presentaciones cantidad",
        },
        unidad_medida: {
          label: "Unidad de medida",
        },
      },
    };

    this.tabla_periodo = {
      //source:'app/getCondicionesEstablecimiento?id=26&',
      target: "#periodo",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      progressText: "Cargando periodo", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rowsPerPage: [5, 10, 25, 50, 100],
      rows: {
        periodo: {
          label: "Periodo de retiro/descarte (días)",
        },
        especie: {
          label: "Especie",
        },
      },
    };

    this.tabla_biologica = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#biologica",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando principio_activo", //El mensaje de carga
      hidePager: true, //Oculta el paginador

      rows: {
        composicion: {
          label: "Composición biológica",
        },
        titulo: {
          label: "Título",
        },
      },
    };

    this.tabla_quimica = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#quimica",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando principio_activo", //El mensaje de carga
      hidePager: true, //Oculta el paginador

      rows: {
        composicion: {
          label: "Composición química",
        },
        concentracion: {
          label: "Concentración",
        },
        unidad_medida: {
          label: "Unidad de medida",
        },
      },
    };

    /**DEFINO MI FORMA para detalles de representante para producto TABLA*/
    this.representante_legal_pro = {
      //source: "app/getRepresentanteProducto?id=5&",
      target: "#representanteLegal_pro",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando representantes legales", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido Materno",
        },
      },
    };

    this.tabla_biologico = {
      target: "#t_biologico",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando detalles", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        cb: {
          label: "Composición biológica",
        },
        u: {
          label: "Título/Unidad de medida",
        },
        c: {
          label: "Categoría",
        },
      },
    };

    /**DEFINO MI FORMA para detalles de regente para producto TABLA*/
    this.regente_pro = {
      //source:'app/getRegenteProducto?id=1&',
      target: "#regente_pro",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando regentes", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        nombres: {
          label: "Nombres",
        },
        apellido_paterno: {
          label: "Apellido paterno",
        },
        apellido_materno: {
          label: "Apellido materno",
        },
      },
    };

    /*    this.tabla_quimica = {
      target: "#t_quimica",
      tableClass: "table table-striped m-b-0 table-hover", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando detalles", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        cq: {
          label: "Composición química",
        },
        cn: {
          label: "Concentración",
        },
        u: {
          label: "Unidad de medida",
        },
      }}; */

    this.tabla_modo_empleo = {
      target: "#modo_empleo",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando detalles", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        dosis: {
          label: "Modo de empleo",
        },
        especie: {
          label: "Especie de destino",
        },
        categoria: {
          label: "Categoría",
        },
      },
    };

    this.tabla_componentes = {
      //source:'app/getRegenteEstablecimiento?id=26&',
      target: "#componente",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando componentes", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        componente: {
          label: "Componentes",
        },
        concentracion: {
          label: "Concentración",
        },
      },
    };

    this.tabla_especies = {
      target: "#especie_interes",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando especies", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        especie_interes: {
          label: "Especie de interés diagnóstico",
        },
      },
    };

    this.tabla_presentacion = {
      target: "#presentaciones",
      tableClass: "table table-striped m-b-0 table-hover blockea", // las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando presentaciones", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        /* presentacion: {
        label: "Presentaciones",
      }, */
        cantidad: {
          label: "Presentaciones cantidad",
        },
        unidad_medida: {
          label: "Unidad de medida",
        },
      },
    };

    this.tabla_analisis = {
      target: "#analisis",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando presentaciones", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        analisis: {
          label: "Análisis garantizado",
        },
        porcentaje: {
          label: "Porcentaje(%)",
        },
      },
    };

    this.tabla_ingredientes = {
      target: "#ingredientes",
      tableClass: "table table-striped m-b-0 table-hover blockea", //las clases de estilo de la tabla
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando presentaciones", //El mensaje de carga
      hidePager: true, //Oculta el paginador
      rows: {
        ingrediente: {
          label: "Ingrediente",
        },
      },
    };

    let anotacion_marginal_producto = {
      target: "#anotacion_marginal_prod",
      disabled: false,
      nombre: "anotacion_marginal_prod",
      render: () => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 12,
            name: "anotacion_marginal_peticion",
            type: "text",
            label: "Anotación Marginal: ",
            disabled: true,
          },
        },
      ],
    };

    this.AnotacionProducto = Api.form(anotacion_marginal_producto);
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle) //
  search = [];

  handleSearch(obj) {
    this.search[obj.target.name] = obj.target.value;
    this.setState({
      buscar: this.search,
    });
  }

  handleClasificacionProd() {
    Swal.fire({
      title: "Clasifique este producto",
      html: this.clasificacion,
      showCancelButton: true,
      confirmButtonText: "Clasificar",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      cancelButtonText: "Cancelar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      preConfirm: () => {
        let dataForm = this.clasificacion.data();
        let solid = this.state.solicitud_pro.id;

        let pass = 1;

        if (dataForm.grupo_ingrediente_id === "0") {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (dataForm.clase_producto_id === "0") {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (dataForm.categorizacion_oficial_id === "0") {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (dataForm.tomo === "" || !dataForm.tomo) {
          Swal.showValidationMessage("Ingrese el tomo");
          pass = 0;
        }

        if (dataForm.folio === "" || !dataForm.folio) {
          Swal.showValidationMessage("Ingrese el folio");
          pass = 0;
        }

        if (dataForm.no_registro_drycip === "" || !dataForm.no_registro_drycip) {
          Swal.showValidationMessage("Ingrese el número de registro");
          pass = 0;
        }

        if (dataForm.dossier === "" || !dataForm.dossier) {
          Swal.showValidationMessage("Ingrese dossier");
          pass = 0;
        }

        if (pass) {
          return Api.fetch(
            "app/setClasification",
            { clasificacion: dataForm, solicitud_id: solid },
            "POST"
          ).then(() => {
            Swal.fire({
              icon: "success",
              title: "Clasificación exitosa.",
              text: "El producto se ha clasificado",
            });
            this.setProductosPage(this.state.paginaActual_p);
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  }
  handleChangeStatusProducto(e, observacion = "", correccion = 0) {
    Api.loading(true);

    if (correccion) {
      e = 6;
    }
    Api.fetch(
      "app/updateStatusProAsesoria",
      {
        id: this.state.solicitud_pro.id,
        status: e,
        observacion: observacion,
        correccion: correccion,
      },
      "PUT"
    ).then((r) => {
      if (e === 2) {
        //ESTE CASO SE HACE PARA AGREGAR CUANDO ES EN ESPERA
        //Notificamos sin obstruir el UI, que todo bien.
        Api.notify(r.message);
      } else {
        Swal.fire(
          "Validación de asesoría legal",
          r.message,
          "info"
        );
        this.modalProAS.close();

        this.setProductosPage(this.state.paginaActual_p);
      }
    });
  }

  handleDownloadZipProductos(e) {
    let docs = "";
    for (let file in this.state.productoDocsCheck) {
      if (this.state.productoDocsCheck[file]) {
        docs += file + ",";
      }
    }
    this.setState({
      previa_url: Api.url + `app/zipP/?docs=` + docs + "&" + Math.random(),
    });
  }

  // Handle Products
  handleProductoStatus(e) {
    let statusString = {
      Aceptar: 5,
      Rechazar: 4,
    };

    let status = statusString[e.target.innerText];

    if (status === 5) {
      Swal.fire({
        title: "¿Aceptar solicitud?",
        text: "Ingrese observaciones si existen.",
        input: "textarea",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusProducto(status, result.value);
          //this.handleCreateOrdenPago();
        }
      });
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar solicitud",
        icon: "warning",
        html: '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" class="form-control" height="30"></textarea>',
        input: "checkbox",
        inputValue: 0,
        inputPlaceholder: "Marcar solicitar corrección",
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        preConfirm: () => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusProducto(e.target.value, razon);
        }
      });
    }
  }

  handleProductosDocumentoStatus(e) {
    e.stopPropagation();
    e.preventDefault();

    let id = e.target.id;
    let estatus = 1;
    let razonText = "";
    let solicitud_id = e.target.getAttribute("data-solicitud_id"); //this.state.solicitud_est.id;//
    let statusString = {
      Aprobar: 2,
      Rechazar: 3,
    };

    estatus = statusString[e.target.getAttribute("data-name")];

    if (estatus === 3) {
      //Si lo rechazas dime por que...

      Swal.fire({
        title: "Descripción del rechazo",
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
        preConfirm: (razon) => {
          if (razon !== "") {
            razonText = razon;
            return true;
          } else {
            Swal.showValidationMessage("Debe ingresar una razón");
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        //rechazado
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setProductoDocumentStatus",
            {
              id: id,
              estatus: 3,
              asesoria: 1,
              razon: razonText,
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            this.setState({ docProductos: r });
            this.handleProBtn();
          });
        }
      });
    } else if (estatus === 2) {
      //aceptado
      Swal.fire({
        title: "¿Seguro que desea aceptar este documento?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setProductoDocumentStatus",
            {
              id: id,
              asesoria: 1,
              estatus: 5,
              razon: "",
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);

            this.setState({ docProductos: r });
            this.handleProBtn();
          });
        }
      });
    }
  }
  /* termina productos */

  /*   handleEstBtn = () =>{  
   
    let rechazos=0;
    let docs = [...this.state.establecimiento.documentos];
    
    let dte = this.detalleAS.querySelector("#detalleEstablecimiento2");
      let estdocs = this.detalleAS.querySelectorAll(".est-doc-status-a"); //

          for(let est in estdocs){
            if(typeof estdocs[est] === "object"){
              if(estdocs[est].innerText==="Rechazado" || estdocs[est].innerText=== "Sin Verificar" || estdocs[est].innerText=== "Aprobado SINAIP"){
                  rechazos++;
              }
            }
          }
          

          this.detalleAS.querySelector("#aprobar_est_a").classList = "hide";
          this.detalleAS.querySelector("#rechazar_est_a").classList = "hide";
    

          if(this.state.solicitud_est.estatus==="En espera Asesoría Legal"){
              if(rechazos===0){
                this.detalleAS.querySelector("#aprobar_est_a").classList="btn btn-success";
              }else{
                this.detalleAS.querySelector("#rechazar_est_a").classList="btn btn-danger";
              }
            }
    } */

  handleEstBtn = () => {
    let rechazos = 0;
    let sin_verificar = 0;

    let estdocs = this.detalleAS.querySelectorAll(".est-doc-status-a"); //

    for (let est in estdocs) {
      if (typeof estdocs[est] === "object") {
        if (
          estdocs[est].innerText === "Rechazado" ||
          estdocs[est].innerText === "Sin Verificar" ||
          estdocs[est].innerText === "Aprobado SINAIP"
        ) {
          rechazos++;
        }

        if (
          estdocs[est].innerText === "Sin Verificar" ||
          estdocs[est].innerText === "Aprobado SINAIP"
        ) {
          sin_verificar++;
        }
      }
    }
    //dte.querySelector("#rechazar_est").classList = "hide";
    this.detalleAS.querySelector("#aprobar_est_a").classList = "hide";

    if (rechazos === 0) {
      this.detalleAS.querySelector("#aprobar_est_a").classList =
        "btn btn-success";
    } else {
      this.detalleAS.querySelector("#rechazar_est_a").classList =
        "btn btn-danger";
    }

    if (sin_verificar === estdocs.length) {
      this.detalleAS.querySelector("#rechazar_est_a").classList =
        "btn btn-danger";
    } else {
      this.detalleAS.querySelector("#rechazar_est_a").classList = "hide";
    }
  };

  handleProBtn = () => {
    let rechazos = 0;
    let sin_verificar = 0;
    let detalleProducto = document.querySelector("#detalleProducto2");
    //let detalleAS = this.detalleAS;

    let prodocs = detalleProducto.querySelectorAll(".pro-doc-status-a");

    if (this.state.solicitud_prod.estatus !== "5") {
      for (let pro in prodocs) {
        if (typeof prodocs[pro] === "object") {
          if (
            prodocs[pro].innerText === "Rechazado" ||
            prodocs[pro].innerText === "Sin Verificar" ||
            prodocs[pro].innerText === "Aprobado SINAIP"
          ) {
            rechazos++;
          }
        }

        if (
          prodocs[pro].innerText === "Sin Verificar" ||
          prodocs[pro].innerText === "Aprobado SINAIP"
        ) {
          sin_verificar++;
        }
      }
    }

    detalleProducto.querySelector("#rechazar_pro_a").classList = "hide";
    detalleProducto.querySelector("#aprobar_pro_a").classList = "hide";

    if (this.state.solicitud_prod.estatus === "En espera Asesoría Legal") {
      if (rechazos <= 0) {
        detalleProducto.querySelector("#aprobar_pro_a").classList =
          "btn btn-success";
      } else {
        detalleProducto.querySelector("#rechazar_pro_a").classList =
          "btn btn-danger";
      }

      if (sin_verificar === prodocs.length) {
        detalleProducto.querySelector("#rechazar_pro_a").classList =
          "btn btn-danger";
      } else {
        detalleProducto.querySelector("#rechazar_pro_a").classList = "hide";
      }
    }
  };

  /* Empieza establecimientos */
  setEstablecimientosPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscarEstablecimientos;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch(
      "app/getSolicitudesEstablecimiento?asesoria=1&page=" + page + src
    ).then((e) => {
      this.setState({
        establecimientos: e.data,
        paginas_e: e.last_page,
        registros_e: e.total,
        paginaActual_e: e.current_page,
        workingGrid: false,
      });
      /* for (let file in e.documentos) {
              this.state.establecimientoDocsCheck[e.documentos[file].id] = false;
            } */
    });
  }

  handleEstablecimientoPage(e) {
    this.setEstablecimientosPage(e.target.value);
  }

  modalEstAS = {};
  detalleAS = {};
  handleOpenEstablecimiento(e) {
    let tituloModal = e.target.dataset.folio;
    let solid = e.target.getAttribute("data-solicitud-id");

    Api.loading(true);

    this.detalleAS = document.querySelector("#detalleEstablecimiento2");
    let detalleAS = this.detalleAS;

    Api.fetch(
      "app/getSolicitudEstablecimiento",
      { solicitud_id: solid },
      "POST"
    ).then((e) => {
      this.setState({
        establecimiento: e,
        solicitud_est: e.solicitud,
        working: false,
      });

      document.getElementById("anotacion_marginal").classList = "col-12 hide";
      if (e.nota_marginal) {
        this.setState({
          am: "NM",
          nota_marginal: e.nota_marginal,
          solicitud_est: e.nota_marginal.solicitud,
        });

        document.getElementById("anotacion_marginal").classList = "col-12";
        document.getElementById("nota_marginal").innerText =
          e.nota_marginal.descripcion;

        document.querySelector(".estTipo").innerText =
          e.nota_marginal.descripcion;

        import(`../components/notas-marginales/NMGeneral.jsx`).then((m) => {
          m.detail(e.nota_marginal, (r) => {
            let notaForm = Api.form(r);
            notaForm.querySelector("#peticion").innerText =
              e.nota_marginal.peticion;
          });
        });
      }

      this.representante_legal.source =
        "app/getRepresentanteEstablecimiento?id=" + e.establecimiento.id + "&";
      this.detalleRepresentante = Api.grid(this.representante_legal);

      this.regente.source =
        "app/getRegenteEstablecimiento?id=" + e.establecimiento.id + "&";
      this.detalleRegente = Api.grid(this.regente);

      this.condiciones.source =
        "app/getCondicionesEstablecimiento?id=" + e.establecimiento.id + "&";
      this.detalleCondiciones = Api.grid(this.condiciones);

      /*  for (let file in e.documentos) {
                this.state.establecimientoDocsCheck[e.documentos[file].id] = false;
              } 
       */
      let edc = [];
      for (let file in e.documentos) {
        edc[e.documentos[file].id] = false;
      }

      this.setState({
        allEst: false,
        establecimientoDocsCheck: edc,
      });

      this.detalleEstablecimientoAS.merge(e.establecimiento);
      if (e.establecimiento.nacional === "1") {
        if (
          this.detalleEstablecimientoAS.querySelector(".pais_texto") != null
        ) {
          this.detalleEstablecimientoAS.querySelector(".pais_texto").remove();
        }
      } else {
        if (this.detalleEstablecimientoAS.querySelector(".municipio") != null) {
          this.detalleEstablecimientoAS.querySelector(".municipio").remove();
          this.detalleEstablecimientoAS.querySelector(".departamento").remove();
        }
      }
      this.detalleCaracteristicas.merge(e.establecimiento);

      /*Abrimos el modal */

      let docAcepta = detalleAS.querySelectorAll(".documento-aceptar");

      docAcepta.forEach((doc) => {
        doc.addEventListener(
          "click",
          this.handleEstablecimientoDocumentoStatus
        );
      });

      let docRechaza = detalleAS.querySelectorAll(".documento-rechazar");

      docRechaza.forEach((doc) => {
        doc.addEventListener(
          "click",
          this.handleEstablecimientoDocumentoStatus
        );
      });

      let docVistaPrevia = detalleAS.querySelectorAll(".vista-previa");
      docVistaPrevia.forEach((doc) => {
        doc.addEventListener("click", this.handlePrevia);
      });

      let checkboxs = detalleAS.querySelectorAll(".checkbox_est_a");
      checkboxs.forEach((doc) => {
        doc.addEventListener("onchange", this.handleEstChecks);
      });

      detalleAS
        .querySelector("#regresar_est_a")
        .addEventListener("click", () => {
          this.modalEstAS.close();
        });

      if (
        this.state.solicitud_est.estatus_tramite_id === "4" ||
        this.state.solicitud_est.estatus_tramite_id === "5"
      ) {
        detalleAS.querySelector("#rechazar_est_a").disabled = "disabled";
        detalleAS.querySelector("#aprobar_est_a").disabled = "disabled";
      } else {
        detalleAS
          .querySelector("#rechazar_est_a")
          .addEventListener("click", this.handleEstablecimientoStatus);
        detalleAS
          .querySelector("#aprobar_est_a")
          .addEventListener("click", this.handleEstablecimientoStatus);
        detalleAS
          .querySelector("#allc_e_a")
          .addEventListener("change", this.allDocsEst);
        detalleAS
          .querySelector("#descarga_docs_est")
          .addEventListener("click", this.handleDownloadZipEstablecimientos);
      }
      this.modalEstAS = Api.modal({
        title: "Folio solicitud: " + tituloModal,
        html: detalleAS,
      });

      this.handleEstBtn();

      Api.loading(false);
    });
  }

  // Funcion para cambiar el estatus de los documentos ESTABLECIMIENTOS
  handleEstablecimientoDocumentoStatus(e) {
    e.stopPropagation();
    e.preventDefault();

    let id = e.target.id; //parseInt(id);
    let estatus = 1;
    let razonText = "";

    let solicitud_id = e.target.getAttribute("data-solicitud_id"); //this.state.solicitud_est.id;//
    let solicitud_estatus = e.target.getAttribute("data-solicitud_estatus"); //this.state.solicitud_est.estatus;

    if (solicitud_estatus === "En espera") {
      // this.handleChangeStatusRegente(2);
    }

    let statusString = {
      Aprobar: 5,
      Rechazar: 3,
    };

    //	estatus = statusString[nom_boton];

    estatus = statusString[e.target.getAttribute("data-name")];

    if (estatus === 3) {
      //Si lo rechazas dime por que...

      Swal.fire({
        title: "Descripción del rechazo",
        input: "textarea",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        preConfirm: (razon) => {
          if (razon !== "") {
            razonText = razon;
            return true;
          } else {
            Swal.showValidationMessage("Debe ingresar una razón");
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        //rechazado
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setEstablecimientoDocumentStatus" + this.state.am,
            {
              id: id,
              estatus: 3,
              asesoria: 0,
              razon: razonText,
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            let est = { ...this.state.establecimiento };
            est["documentos"] = r.documentos;
            this.setState({ establecimiento: est, solicitud_est: r.solicitud });
            this.handleEstBtn();
          });
        }
      });
    } else if (estatus === 5) {
      //aceptado
      Swal.fire({
        title: "¿Seguro que desea aceptar este documento?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setEstablecimientoDocumentStatus" + this.state.am,
            {
              id: id,
              asesoria: 1,
              estatus: 5,
              razon: "",
              solicitud_id: solicitud_id,
            },
            "POST"
          ).then((r) => {
            Api.loading(false);
            let est = { ...this.state.establecimiento };
            est["documentos"] = r.documentos;
            this.setState({ establecimiento: est, solicitud_est: r.solicitud });
            this.handleEstBtn();
          });
        }
      });
    }
  }

  //Funcion para controlar los checkbox de los documentos del establecimiento
  handleEstChecks(e) {
    let rChk = {};
    rChk = this.state.establecimientoDocsCheck;
    rChk[e.target.id] = e.target.checked;

    this.setState({
      establecimientoDocsCheck: rChk,
      allEst: false,
    });
  }

  handleProChecks(e) {
    let rChk = {};
    rChk = this.state.productoDocsCheck;
    rChk[e.target.id] = e.target.checked;
    this.setState({
      productoDocsCheck: rChk,
      allPro: false,
    });
  }

  //Funcion para switchear entre marcado y desmarcado de todos checkbox

  allDocsEst(e) {
    let rChk = [];
    for (let file in this.state.establecimiento.documentos) {
      rChk[this.state.establecimiento.documentos[file].id] = e.target.checked;
    }

    this.setState({
      establecimientoDocsCheck: rChk,
      allEstDocs: e.target.checked,
      allEst: e.target.checked,
    });
  }

  allDocsPro(e) {
    let rChk2 = [];

    for (let file in this.state.docProductos) {
      rChk2[this.state.docProductos[file].id] = e.target.checked;
    }
    
    this.setState({
      productoDocsCheck: rChk2,
      allProDocs: e.target.checked,
      allPro: e.target.checked,
    });
  }

  // Funcion para solicitar la descarga de los documentos del establecimiento
  handleDownloadZipEstablecimientos(e) {
    let docs = "";
    for (let file in this.state.establecimientoDocsCheck) {
      if (this.state.establecimientoDocsCheck[file]) {
        docs += file + ",";
      }
    }
    this.setState({
      previa_url:
        Api.url +
        `app/zipE${this.state.am}/?docs=` +
        docs +
        "&" +
        Math.random(),
    });
  }

  // Funcion para mostrar las vistas previas en grande y/o forzar la descarga
  handlePrevia(e) {
    let doc = e.target.getAttribute("data-file");
    this.setState({
      previa: true,
      previa_url: doc,
    });
  }

  //Funcion para controlar el estado de la solicitud, rechazada o aceptada de regente
  handleEstablecimientoStatus(e) {
    let statusString = {
      Aceptar: 5,
      "Rechazar solicitud": 4,
    };

    let status = statusString[e.target.innerText];

    if (status === 5) {
      Swal.fire({
        title: "¿Aceptar solicitud?",
        text: "Ingrese observaciones si existen.",
        input: "textarea",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusEstablecimiento(e.target.value, result.value);
          if (this.state.am === "") {
            this.handleCreateLicense();
          }
          //this.handleCreateOrdenPago();
        }
      });
    } else {
      let razon = "";
      Swal.fire({
        title: "Rechazar solicitud",
        icon: "warning",
        html: '<textarea id="swal-input1" placeholder="Ingrese razón del rechazo" class="form-control" height="30"></textarea>',
        input: "checkbox",
        inputValue: 0,
        inputPlaceholder: "Marcar solicitar corrección",
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        preConfirm: () => {
          razon = document.querySelector("#swal-input1").value;
          if (razon === "") {
            Swal.showValidationMessage(
              "Es obligatorio ingresar una observación"
            );
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.handleChangeStatusEstablecimiento(
            e.target.value,
            razon,
            result.value
          );
        }
      });
    }
  }

  handleCreateLicense() {
    const postData = this.state.solicitud_est.id;

    Api.fetch(
      "app/createLicenseEstablecimiento",
      { id: postData },
      "post"
    ).then((r) => {
      //Notificamos sin obstruir el UI, que todo bien.
      Api.notify(r.message);
    });
  }
  //Funcion para postear el status
  handleChangeStatusEstablecimiento(e, observacion = "", correccion = 0) {
    Api.loading(true);
    //Si requerimos corrección entonces cambiamos su estatus al 6 que corresponde a correccion
    if (correccion) {
      e = 6;
    }

    let solid = this.state.solicitud_est.id;

    if (this.state.am !== "" && e != 4) {
      solid = this.state.nota_marginal.solicitud_id;
      e = 13;
    }

    Api.fetch(
      "app/updateStatusEst" + this.state.am,
      {
        id: solid,
        status: e,
        observacion: observacion,
        correccion: correccion,
      },
      "PUT"
    ).then((r) => {
      if (e === 5) {
        //ESTE CASO SE HACE PARA AGREGAR CUANDO ES EN ESPERA
        //Notificamos sin obstruir el UI, que todo bien.
        Api.notify(r.message);
      } else {
        // No necesitamos refrescar, solo invocar la pagina actual del grid de regentes
        this.setEstablecimientosPage(this.state.paginaActual);
        // Luego cerramos el modal
        Api.loading(true);
        this.modalEstAS.close();

        this.setState({ modalEstablecimiento: false });
        Api.loading(false);
      }
    });
  }

  render() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "1" })}
                onClick={() => {
                  this.toggleTab("1");
                }}
              >
                <span className="d-sm-none">
                  ESTABLECIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_e}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  ESTABLECIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_e}
                  </span>
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === "2" })}
                onClick={() => {
                  this.toggleTab("2");
                }}
              >
                <span className="d-sm-none">
                  PRODUCTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_p}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  PRODUCTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_p}
                  </span>
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaEstablecimiento"></div>
                </fieldset>
                <hr></hr>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Solicitud</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Razón social</th>
                      <th className="text-center">Tipo establecimiento</th>
                      <th className="text-center">Tipo actividad</th>
                      <th className="text-center">Aprobación SINAIP</th>
                      <th className="text-center">Estado</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.establecimientos.map((est) => (
                      <tr
                        key={est.id}
                        className={
                          est.dias > 15 && est.estatus === "En espera"
                            ? "alerta"
                            : ""
                        }
                      >
                        <td className="text-center">{est.folio_solicitud}</td>
                        <td className="text-center">{est.solicitud}</td>
                        {/*<td className="text-center">{est.nombre}</td>*/}

                        <td className="text-center">
                          {format(new Date(est.fecha_solicitud), "dd/MM/yyyy")}
                        </td>
                        <td className="text-center">{est.razon_social}</td>
                        <td className="text-center" title={est.tipo}>
                          {est.tipo.substr(0, 100)}...
                        </td>
                        <td className="text-center" title={est.actividad}>
                          {est.actividad.substr(0, 100)}...
                        </td>
                        <td align="center">
                          {est.fecha_aprueba_sinaip !== null
                            ? est.fecha_aprueba_sinaip
                                .split("-")
                                .reverse()
                                .join("-")
                                .replaceAll("-", "/")
                            : ""}
                        </td>
                        <td className="text-center">{est.estatus}</td>
                        <td className="text-center">
                          {est.estatus_tramite_id === "10" ||
                          est.estatus_tramite_id === "5" ? (
                            <button
                              onClick={this.handleOpenEstablecimiento}
                              id={"button_est_a_" + est.id}
                              data-solicitud-id={est.id}
                              data-establecimiento_id={est.establecimiento_id}
                              data-folio={est.folio_solicitud}
                              className="btn bg-gradient-blue"
                            >
                              <i
                                id={"i_est_a_" + est.id}
                                data-establecimiento_id={est.establecimiento_id}
                                data-folio={est.folio_solicitud}
                                data-solicitud-id={est.id}
                                className="fas fa-folder-open"
                              ></i>
                            </button>
                          ) : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setEstablecimientosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_e - 1 > 0) {
                            this.setEstablecimientosPage(
                              this.state.paginaActual_e - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_e} de {this.state.paginas_e}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_e >=
                            this.state.paginaActual_e + 1
                          ) {
                            this.setEstablecimientosPage(
                              this.state.paginaActual_e + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setEstablecimientosPage(this.state.paginas_e);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleEstablecimientoPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_e}
                      value={this.state.paginaActual_e}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="2">
              <div className="table-responsive">
                <fieldset>
                  <div id="busquedaProducto"></div>
                </fieldset>
                <hr></hr>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Solicitud</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Nombre comercial</th>
                      <th className="text-center">Tipo producto</th>
                      <th className="text-center">Aprobación SINAIP</th>
                      <th className="text-center">Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.productos.map((pro, index) => (
                      <tr key={index}>
                        <td className="text-center">{pro.folio_solicitud}</td>
                        <td className="text-center">{pro.solicitud}</td>
                        <td className="text-center">
                          {format(new Date(pro.fecha_solicitud), "dd/MM/yyyy")}
                        </td>
                        <td className="text-center">{pro.nombre_comercial}</td>
                        <td className="text-center">{pro.tipo_producto}</td>

                        <td align="center">
                          {pro.fecha_aprueba_sinaip !== null
                            ? pro.fecha_aprueba_sinaip
                                .split("-")
                                .reverse()
                                .join("-")
                                .replaceAll("-", "/")
                            : ""}
                        </td>
                        <td className="text-center">{pro.descripcion}</td>
                        <td className="text-center">
                          {pro.estatus_tramite_id === "10" ||
                          pro.estatus_tramite_id === "5" ? (
                            <button
                              onClick={this.handleOpenProductos}
                              id={"button_pro_a_" + pro.id}
                              data-producto_id={pro.producto_id}
                              data-folio={pro.folio_solicitud}
                              data-solicitud-id={pro.solicitud_id}
                              className="btn bg-gradient-blue"
                            >
                              <i
                                id={"i_pro_a_" + pro.id}
                                data-solicitud-id={pro.solicitud_id}
                                data-producto_id={pro.producto_id}
                                data-folio={pro.folio_solicitud}
                                className="fas fa-folder-open"
                              ></i>
                            </button>
                          ) : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setProductosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_p - 1 > 0) {
                            this.setProductosPage(
                              this.state.paginaActual_p - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_p} de {this.state.paginas_p}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_p >=
                            this.state.paginaActual_p + 1
                          ) {
                            this.setProductosPage(
                              this.state.paginaActual_p + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setProductosPage(this.state.paginas_p);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setProductosPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_p}
                      value={this.state.paginaActual_p}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
          </TabContent>
        </div>

        <div className={this.state.previa ? "previa" : "hide"}>
          <iframe className="rounded" src={this.state.previa_url}></iframe>
          <center>
            <div className="btn-group">
              <button
                onClick={() => {
                  this.setState({ previa: false });
                }}
                className="btn btn-white"
              >
                Cerrar
              </button>
              <a
                className="btn btn-primary"
                href={this.state.previa_url + "&download=1"}
                download
              >
                Descargar
              </a>
            </div>
          </center>
        </div>

        <Modal
          isOpen={this.state.modalEstablecimiento}
          modalClassName="modal-message"
        >
          <ModalHeader
            toggle={() => this.setState({ modalEstablecimiento: false })}
          >
            Folio de solicitud:
          </ModalHeader>
          <ModalBody>
            <fieldset className="col-sm-12">
              <legend>Detalles del establecimiento</legend>
            </fieldset>
          </ModalBody>
        </Modal>

        <div className="hide">
          <div id="detalleEstablecimiento2">
            <div className="row">
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Solicitud</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_est.accion}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Tipo</div>

                    <div className="stats-desc">
                      <h5 className="estTipo">
                        {this.state.solicitud_est.tipo}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Estado</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_est.estatus}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Fecha</div>

                    <div className="stats-desc">
                      <h5>
                        {this.state.solicitud_est.fecha_solicitud
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("-")
                          .replaceAll("-", "/")}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <hr></hr>
              <div className="col-12">
                <fieldset>
                  <legend>detalles establecimiento</legend>
                  <div id="establecimiento"></div>
                </fieldset>
              </div>
              <hr></hr>
              <div className="col-12">
                <fieldset>
                  <legend>Detalles del representante legal</legend>
                  <div id="representanteLegal"></div>
                </fieldset>
              </div>
              <hr></hr>
              <div className="col-12">
                <fieldset>
                  <legend>Detalles de regentes</legend>
                  <div id="regente"></div>
                </fieldset>
              </div>

              <div className="col-12">
                <fieldset>
                  <legend>Características del establecimiento</legend>
                  <div id="caracteristicas"></div>
                  <hr></hr>
                  <div id="condiciones"></div>
                </fieldset>
              </div>

              <div className="col-12 hide" id="anotacion_marginal">
                <fieldset className="orange-stroke">
                  <legend>
                    Anotación marginal <b id="nota_marginal"></b>
                  </legend>
                  <div id="detalle_ame"></div>
                </fieldset>
              </div>

              <div className="col-12">
                <fieldset
                  className={
                    this.state.establecimiento.documentos.length
                      ? "col-md-12"
                      : "hide"
                  }
                >
                  <legend>Documentación</legend>
                  <div className="table-responsive">
                    <button
                      className="btn btn-primary pull-right"
                      id="descarga_docs_est"
                      //onClick={this.handleDownloadZipEstablecimientos}
                    >
                      Descargar selección
                    </button>
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th width="50">
                            <div className="checkbox checkbox-inline checkbox-css">
                              <input
                                onChange={this.allDocsEst}
                                type="checkbox"
                                value={this.state.allEst || false}
                                name="allc_e_a"
                                checked={this.state.allEst || false}
                                id="allc_e_a"
                              />
                              <label htmlFor="allc_e_a">Todos</label>
                            </div>
                          </th>
                          <th className="text-center">Vista previa</th>
                          <th className="text-center">Documento</th>
                          <th className="text-center">Fecha carga</th>
                          <th className="text-center">Estado</th>
                          <th className="text-center">
                            Fecha aprobación SINAIP
                          </th>
                          <th className="text-center">
                            Fecha aprobación asesoría legal
                          </th>
                          <th className="text-center">Acción</th>
                        </tr>
                      </thead>
                      <tbody className={this.state.working ? "hide" : "show"}>
                        {this.state.establecimiento.documentos.map((est) => (
                          <tr key={est.id}>
                            <td className="text-center">
                              <div className="checkbox checkbox-inline checkbox-css">
                                <input
                                  type="checkbox"
                                  className="checkbox_est_a"
                                  id={"est-a-s" + est.id}
                                  onChange={() => {}}
                                  name={"est-a-s" + est.id}
                                  value={
                                    this.state.establecimientoDocsCheck[
                                      est.id
                                    ] || false
                                  }
                                  checked={
                                    this.state.establecimientoDocsCheck[
                                      est.id
                                    ] || false
                                  }
                                />
                                <label htmlFor={"est-a-s" + est.id}> </label>
                              </div>
                            </td>
                            <td align="center">
                              <img
                                className="rounded btn vista-previa"
                                data-file={
                                  Api.url +
                                  `app/documentoE${this.state.am}/?id=${est.id}`
                                }
                                //onClick={this.handlePrevia}
                                width="60"
                                src={
                                  Api.url +
                                  `app/documentoE${this.state.am}/?id=${est.id}&thumb=1`
                                }
                              />
                            </td>
                            <td className="text-center">
                              {est.documento.replace(
                                "**ACTIVIDAD**",
                                est.actividad
                              )}
                            </td>
                            <td align="center">
                              {est.created !== null
                                ? format(new Date(est.created), "dd/MM/yyyy")
                                : ""}
                            </td>
                            <td className="text-center est-doc-status-a">
                              {est.estatus}
                            </td>
                            <td align="center">
                              {est.fecha_aprueba_sinaip !== null
                                ? format(
                                    new Date(est.fecha_aprueba_sinaip),
                                    "dd/MM/yyyy"
                                  )
                                : ""}
                            </td>
                            <td align="center">
                              {est.fecha_aprueba_asesoria !== null
                                ? format(
                                    new Date(est.fecha_aprueba_asesoria),
                                    "dd/MM/yyyy"
                                  )
                                : ""}
                            </td>
                            <td className="text-center">
                              <div className="btn-group">
                                <a
                                  href={
                                    Api.url +
                                    `app/documentoE${this.state.am}/?id=${est.id}&download=1`
                                  }
                                  className="btn btn-primary"
                                >
                                  <i className="fas fa-file-download"></i>
                                </a>
                                <button
                                  className="btn btn-danger documento-rechazar"
                                  data-solicitud_id={est.solicitud_id}
                                  data-solicitud_estatus={est.estatus}
                                  //id={"btn-est-a" + est.id}
                                  id={est.id}
                                  onClick={
                                    this.handleEstablecimientoDocumentoStatus
                                  }
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  name="Rechazar"
                                  disabled={
                                    (est.aprobado !== "1" && est.aprobado !== "4") || this.state.solicitud_est.estatus_tramite_id === 4
                                      ? true
                                      : false
                                  }
                                  data-name="Rechazar"
                                >
                                  <i
                                    className="fas fa-ban documento-rechazar"
                                    data-solicitud_id={est.solicitud_id}
                                    data-solicitud_estatus={est.estatus}
                                    //id={"i-est-" + est.id}
                                    id={est.id}
                                    onClick={
                                      this.handleEstablecimientoDocumentoStatus
                                    }
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Rechazar"
                                    disabled={
                                      (est.aprobado !== "1" &&
                                      est.aprobado !== "4") || this.state.solicitud_est.estatus_tramite_id === 4
                                        ? true
                                        : false
                                    }
                                  ></i>{" "}
                                  Rechazar
                                </button>
                                <button
                                  className="btn btn-success documento-aceptar"
                                  data-solicitud_id={est.solicitud_id}
                                  data-solicitud_estatus={est.estatus}
                                  id={est.id}
                                  onClick={
                                    this.handleEstablecimientoDocumentoStatus
                                  }
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-name="Aprobar"
                                  disabled={
                                    (est.aprobado !== "1" && est.aprobado !== "4") || this.state.solicitud_est.estatus_tramite_id === 4
                                      ? true
                                      : false
                                  }
                                >
                                  <i
                                    className="fas fa-check  documento-aceptar"
                                    data-solicitud_id={est.solicitud_id}
                                    data-solicitud_estatus={est.estatus}
                                    id={est.id}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Aprobar"
                                    disabled={
                                      (est.aprobado !== "1" &&
                                      est.aprobado !== "4") || this.state.solicitud_est.estatus_tramite_id === 4
                                        ? true
                                        : false
                                    }
                                  ></i>{" "}
                                  Aprobar
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </fieldset>
              </div>
              <div className="col-md-12">
                {/* <div className="btn-group  pull-left">
                  <button
                    className="btn btn-white "
                    onClick={() => {
                      this.setEstablecimientosPage(this.state.paginaActual);
                      this.setState({ modalEstablecimiento: false });
                    }}>
                    Regresar
                  </button>
                </div> */}
                <div className="btn-group pull-left col-md-4">
                  <button
                    onClick={this.handleEstablecimientoStatus}
                    value="4"
                    id="rechazar_est_a"
                    className="btn btn-danger"
                  >
                    Rechazar Solicitud
                  </button>
                </div>
                <div className="btn-group pull-right col-md-4">
                  <button id="regresar_est_a" className="btn btn-white ">
                    Regresar
                  </button>

                  <button
                    onClick={this.handleEstablecimientoStatus}
                    value="5"
                    id="aprobar_est_a"
                    className="btn btn-success hide"
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/***************  DETALLE PRODUCTO  ***************/}
        <div className="hide">
          <div id="detalleProducto2">
            <div className="row">
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Trámite</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_prod.accion}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Tipo</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_prod.tipo}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Estado</div>

                    <div className="stats-desc">
                      <h5>{this.state.solicitud_prod.estatus}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Fecha</div>

                    <div className="stats-desc">
                      <h5>
                        {this.state.solicitud_prod.fecha_solicitud != null
                          ? this.state.solicitud_prod.fecha_solicitud
                              .split("-")
                              .join("-")
                              .replaceAll("-", "/")
                          : this.state.solicitud_prod.fecha_solicitud}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-12">
                {this.state.solicitud_prod.tramite_id !== "11" ? (
                  <div>
                    {/* <fieldset>
                    <legend>Comercial</legend>
                    <div id="d_nombre"></div>
                    </fieldset> */}
                    <hr></hr>
                    <div id="producto">
                      <fieldset>
                        <legend>
                          Detalle del producto{" "}
                          {this.state.solicitud_prod.tipo_producto_veterinario}
                        </legend>
                        <div id="d_producto"></div>
                        {/*    <div id="d_producto_vet" className={((this.state.solicitud_prod.tipo_producto_id !== "reactivos_diagnosticos" )? "" : "hide")}></div>
                        <div id="d_producto_bio" className={((this.state.solicitud_prod.tipo_producto_id !== "reactivos_diagnosticos" )? "" : "hide")}></div> */}
                      </fieldset>
                      <hr></hr>
                      <fieldset>
                        <legend>Detalles tipo de producto</legend>
                        <div
                          id="producto_activo"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "1" ||
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "3"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="excipiente"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "1" ||
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "3"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="biologica"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "2"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="quimica"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "2"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="analisis"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "5"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="ingredientes"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "5"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="dosis"
                          className={
                            this.state.solicitud_pro
                              .tipo_producto_veterinario_id === "3" ||
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "4"
                              ? "hide"
                              : ""
                          }
                        ></div>
                        <div
                          id="modo_empleo"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "3"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="envase"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id !== "4"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="periodo"
                          className={
                            this.state.solicitud_pro
                              .tipo_producto_veterinario_id === "3" ||
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "4"
                              ? "hide"
                              : ""
                          }
                        ></div>
                        <div
                          id="componente"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "4"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="especie_interes"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "4"
                              ? ""
                              : "hide"
                          }
                        ></div>
                        <div
                          id="presentaciones"
                          className={
                            this.state.solicitud_prod
                              .tipo_producto_veterinario_id === "4"
                              ? ""
                              : "hide"
                          }
                        ></div>
                      </fieldset>
                    </div>
                    <hr></hr>
                    {/* <fieldset>
                        <legend>Representantes Legales</legend>
                        <div id="representanteLegal_pro"></div>
                      </fieldset> 
                      <hr></hr>*/}
                    <fieldset>
                      <legend>Regente</legend>
                      <div id="regente_pro"></div>
                    </fieldset>

                    <fieldset
                      className={
                        this.state.solicitud_prod.anotacion_marginal
                          ? ""
                          : "hide"
                      }
                    >
                      <legend>
                        Anotación Marginal{" "}
                        {this.state.solicitud_prod.anotacion_marginal}
                      </legend>
                      <div id="anotacion_marginal_prod"></div>
                    </fieldset>
                  </div>
                ) : (
                  <div>
                    <fieldset>
                      <legend>Detalle de refrenda</legend>
                      <div id="f_refrenda" className=""></div>
                    </fieldset>
                    <hr></hr>
                    <fieldset>
                      <legend>Productos refrenda</legend>
                      <div id="refrenda_productos"></div>
                    </fieldset>
                  </div>
                )}

                <hr></hr>
                <fieldset
                  className={
                    this.state.docProductos.length ? "col-md-12" : "hide"
                  }
                >
                  <legend>Documentación</legend>
                  <div className="table-responsive">
                    <button
                      className="btn btn-primary pull-right"
                      id="descarga_docs_pro_a"
                    >
                      Descargar selección
                    </button>
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th width="50">
                            <div className="checkbox checkbox-inline checkbox-css">
                              <input
                                onChange={this.allDocsPro}
                                type="checkbox"
                                value={this.state.allPro || false}
                                name="allc_p_a"
                                checked={this.state.allPro || false}
                                id="allc_p_a"
                              />
                              <label htmlFor="allc_p_a">Todos</label>
                            </div>
                          </th>
                          <th className="text-center">Vista previa</th>
                          <th className="text-center">Documento</th>
                          <th className="text-center">Fecha carga</th>
                          <th className="text-center">Estado</th>
                          <th className="text-center">
                            Fecha aprobación SINAIP
                          </th>
                          <th className="text-center">
                            Fecha aprobación asesoría legal
                          </th>
                          <th className="text-center">Acción</th>
                        </tr>
                      </thead>
                      <tbody className={this.state.working ? "hide" : "show"}>
                        {this.state.docProductos.map((dpro) => (
                          <tr key={dpro.id}>
                            <td className="text-center">
                              <div className="checkbox checkbox-inline checkbox-css">
                                <input
                                  type="checkbox"
                                  className="checkbox_pro_a"
                                  id={dpro.id}
                                  name={"dpro-" + dpro.id}
                                  value={
                                    this.state.productoDocsCheck[dpro.id] ||
                                    false
                                  }
                                  checked={
                                    this.state.productoDocsCheck[dpro.id] ||
                                    false
                                  }
                                  onChange={() => {}} //onChange={this.handleProChecks}
                                />
                                <label htmlFor={dpro.id}></label>
                              </div>
                            </td>
                            <td className="text-center">
                              <img
                                alt="Vista previa"
                                className="rounded btn vista-previa"
                                data-file={
                                  this.state.solicitud_prod
                                    .anotacion_marginal === false
                                    ? Api.url + `app/documentoP/?id=${dpro.id}`
                                    : Api.url +
                                      `app/documentoPAM/?id=${dpro.id}`
                                }
                                width="60"
                                src={
                                  this.state.solicitud_prod
                                    .anotacion_marginal === false
                                    ? Api.url +
                                      `app/documentoP/?id=${dpro.id}&thumb=1`
                                    : Api.url +
                                      `app/documentoPAM/?id=${dpro.id}&thumb=1`
                                }
                              />
                            </td>
                            <td className="text-center">{dpro.documento}</td>
                            <td className="text-center">
                              {dpro.created
                                ? format(new Date(dpro.created), "dd/MM/yyyy")
                                : ""}
                            </td>
                            <td className="text-center pro-doc-status-a">
                              {dpro.estatus}
                            </td>
                            <td className="text-center">
                              {dpro.fecha_aprueba_sinaip
                                ? dpro.fecha_aprueba_sinaip
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                    .replaceAll("-", "/")
                                : ""}
                            </td>
                            <td className="text-center">
                              {dpro.fecha_aprueba_asesoria
                                ? dpro.fecha_aprueba_asesoria
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                    .replaceAll("-", "/")
                                : ""}
                            </td>

                            <td className="text-center">
                              <div className="btn-group">
                                <a
                                  href={
                                    this.state.solicitud_prod
                                      .anotacion_marginal === false
                                      ? Api.url +
                                        `app/documentoP/?id=${dpro.id}&download=1`
                                      : Api.url +
                                        `app/documentoPAM/?id=${dpro.id}&download=1`
                                  }
                                  className="btn btn-primary"
                                >
                                  <i className="fas fa-file-download"></i>
                                </a>
                                <button
                                  className="btn btn-danger documento-pro-rechazar"
                                  data-solicitud_id={dpro.solicitud_id}
                                  data-solicitud_estatus={dpro.estatus}
                                  id={dpro.id}
                                  onClick={this.handleProductosDocumentoStatus}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-name="Rechazar"
                                  disabled={
                                    (dpro.aprobado !== "1" &&
                                      dpro.aprobado !== "4") ||
                                    this.state.solicitud_prod
                                      .estatus_tramite_id === "5"
                                      ? true
                                      : false
                                  }
                                >
                                  <i
                                    className="fas fa-ban"
                                    data-solicitud_id={dpro.solicitud_id}
                                    data-solicitud_estatus={dpro.estatus}
                                    id={dpro.id}
                                    onClick={
                                      this.handleProductosDocumentoStatus
                                    }
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Rechazar"
                                    disabled={
                                      (dpro.aprobado !== "1" &&
                                        dpro.aprobado !== "4") ||
                                      this.state.solicitud_prod
                                        .estatus_tramite_id === "5"
                                        ? true
                                        : false
                                    }
                                  ></i>{" "}
                                  Rechazar
                                </button>
                                <button
                                  className="btn btn-success documento-pro-aceptar"
                                  data-solicitud_id={dpro.solicitud_id}
                                  data-solicitud_estatus={dpro.estatus}
                                  id={dpro.id}
                                  onClick={this.handleProductosDocumentoStatus}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-name="Aprobar"
                                  disabled={
                                    (dpro.aprobado !== "1" &&
                                      dpro.aprobado !== "4") ||
                                    this.state.solicitud_prod
                                      .estatus_tramite_id === "5"
                                      ? true
                                      : false
                                  }
                                >
                                  <i
                                    className="fas fa-check  documento-aceptar"
                                    data-solicitud_id={dpro.solicitud_id}
                                    data-solicitud_estatus={dpro.estatus}
                                    id={dpro.id}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Aprobar"
                                    disabled={
                                      (dpro.aprobado !== "1" &&
                                        dpro.aprobado !== "4") ||
                                      this.state.solicitud_prod
                                        .estatus_tramite_id === "5"
                                        ? true
                                        : false
                                    }
                                  ></i>{" "}
                                  Aprobar
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </fieldset>
                <template>
                  <div id="clasificacion"></div>
                </template>
              </div>
              <div className="col-md-12">
                {/* <div className="btn-group  pull-left">
                    <button
                      className="btn btn-white "
                      onClick={() => {
                        this.setEstablecimientosPage(this.state.paginaActual);
                        this.setState({ modalEstablecimiento: false });
                      }}>
                      Regresar
                    </button>
                  </div> */}
                <div className="btn-group pull-left col-md-4">
                  <button
                    onClick={this.handleProductoStatus}
                    value="4"
                    id="rechazar_pro_a"
                    className="btn btn-danger "
                  >
                    Rechazar
                  </button>
                </div>
                <div className="btn-group pull-right col-md-4">
                  <button id="regresar_pro_a" className="btn btn-white ">
                    Regresar
                  </button>
                  <button
                    onClick={this.handleProductoStatus}
                    value="10"
                    id="aprobar_pro_a"
                    className="btn btn-success hide "
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

//export default SolicitudAL;
export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <SolicitudAL auth={auth} history={history} {...props} />;
};
